export const queryKeys = {
  profile: 'profile',
  permissions: 'permissions',
};
